// TODO: class ClientError extends Error {} ???
// TODO: check stacktrace js and stuff

const CONSTANTS     = require('../lib/constants');

function ClientError(errorCode, message, errorLevel){
	// var error = new Error(message);

	// inherit from error object
	// this.constructor.prototype.__proto__ = Error.prototype;
	// make stack getter available (not working in all browsers but necessary for StackTrace-JS
	// try { Error.captureStackTrace(this, this.constructor); } catch(silentError){ }
	// Error.captureStackTrace(this, this.constructor);
	// use default behaviour for printing this error
	this.name = this.constructor.name;
	// custom error code
	this.errorCode  = errorCode || 'UNKOWN_ERROR';
	// basic error message
	this.message    = message || '';
	// the error level tells how critical the error is
	this.errorLevel = errorLevel || CONSTANTS.ERROR.LEVEL.ERROR;
	// dummy field for Component.showError()
	this.statusCode = 'clientError'

}

ClientError.prototype = Error.prototype;

module.exports = ClientError;